import { render, staticRenderFns } from "./commissionPlanDialog.vue?vue&type=template&id=5868dffa&scoped=true"
import script from "./commissionPlanDialog.vue?vue&type=script&lang=js"
export * from "./commissionPlanDialog.vue?vue&type=script&lang=js"
import style0 from "./commissionPlanDialog.vue?vue&type=style&index=0&id=5868dffa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5868dffa",
  null
  
)

export default component.exports